<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="heading-image-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header-container">
                        <h2
                            class="title h3"
                            v-test:title
                        >
                            {{ title }}
                        </h2>
                    </div>
                    <div
                        v-if="mobileImage.src || desktopImage.src"
                        class="image-container"
                    >
                        <lazy-image
                            v-if="mobileImage.src || desktopImage.src"
                            :src="mobileImage.src ? mobileImage.src : desktopImage.src"
                            :alt="mobileImage.alt ? mobileImage.alt : desktopImage.alt"
                            :width="mobileImage.src ? mobileImage.width : desktopImage.width"
                            :height="mobileImage.width ? mobileImage.height : desktopImage.height"
                            class="mobile-image"
                            v-test:mobileImage
                        />

                        <lazy-image
                            v-if="desktopImage.src"
                            :src="desktopImage.src"
                            :alt="desktopImage.alt"
                            :width="desktopImage.width"
                            :height="desktopImage.height"
                            class="desktop-image"
                            v-test:desktopImage
                        />
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    export default {
        name: 'heading-image-section',

        props: {
            mobileImage: {
                type: Object,
                default: () => ({}),
            },

            desktopImage: {
                type: Object,
                required: true,
                default: () => ({}),
            },

            title: {
                type: String,
                required: true,
                default: '',
            },
        },
    };
</script>

<style lang="scss" scoped>
    .heading-image-section {
        padding: 25px 0;
    }

    .title {
        font-weight: bold;
        text-align: center;
    }

    .lazy-image {
        max-width: 100%;
        margin: 0 auto;
        height: auto;
    }

    .mobile-image {
        display: block;

        @include media-breakpoint-up(md) {
            display: none;
        }
    }

    .desktop-image {
        display: none;

        @include media-breakpoint-up(md) {
            display: block;
        }
    }
</style>
